import React from 'react';
import {useSelector} from 'react-redux';
import styled from 'styled-components';
import {labels} from '../../../../../../../../util/utils';
import Modal from '../../../../../../../Common/Modal/Modal';
import ClientDataWrapper from './clientDataWrapper';
import {getAllStEntities} from '../../../../../../../../selectors/Ares/selectors';

const ClientDataModal = ({showModal, account, setShowModal, includeAnnotations = true, stEntityId}) => {
	const stEntities = useSelector((state) => getAllStEntities(state));
	const entity = stEntities?.find((item) => item?.id === stEntityId);

	return (
		<Modal
			closeTitle={labels.closeLabel}
			modalContainerClass="clientDataModal"
			modalbodystyle={'clientDataModalBody'}
			modalsize="large"
			onHide={() => {
				setShowModal(false);
			}}
			show={showModal}
			title={account.accountName + ' - ' + labels.accountDetails}
			showButtons
			closeBtnTitle={labels.closeLabel}
			hideConfirmButton
		>
			<StyeledClientDataModal className="StyeledClientDataModal">
				{stEntityId > 0 && (
					<span className="stEntityNameText">{`${entity?.stEntityShortName} ${entity?.stEntityName}`}</span>
				)}
				<ClientDataWrapper account={account} includeAnnotations={includeAnnotations} stEntityId={stEntityId} />
			</StyeledClientDataModal>
		</Modal>
	);
};

export default ClientDataModal;

const StyeledClientDataModal = styled.section`
	display: flex;
	flex-direction: column;
	height: 100%;
	.stEntityNameText {
		font-size: var(--px-16);
		font-weight: 400;
		color: var(--neutrals-900);
		line-height: var(--px-24);
		margin-bottom: var(--px-24);
		border-bottom: 1px solid var(--neutrals-100);
		padding-bottom: var(--px-24);
	}
	.noDataAvailable {
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		width: 100%;
		background: var(--neutrals-00white);
		color: var(--neutrals-700);
		font-size: var(--px-14);
		font-weight: 300;
	}
`;
